import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import InfraccionesGrid from './InfraccionesGrid.js'
import InfraccionesAbm from './InfraccionesAbm.js'
import InfraccionesPago from './InfraccionesPago.js'
import {FormattedMessage, injectIntl} from 'react-intl';

class Infracciones extends Component {
	render() {
	    return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
      					<h3 className="content-header-title"><FormattedMessage id="infracciones.header_administracion_infracciones" defaultMessage="Administración de Infracciones"/></h3>
      				</div>
				</div>
				<div className="content-body">								
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={InfraccionesGrid} />
						<Route exact path={`${this.props.match.url}/add`} render={(props) => <InfraccionesAbm {...props} action="ADD" />} />
						<Route exact path={`${this.props.match.url}/:id/edit`} render={(props) => <InfraccionesAbm {...props} action="EDIT" />} />
						<Route exact path={`${this.props.match.url}/:id/pay`} render={(props) => <InfraccionesPago {...props} action="PAY" />} />
						<Route path={`${this.props.match.url}/:id`} render={(props) => <InfraccionesAbm {...props} action="VIEW" />} />
					</Switch>										
				</div>
			</div>
	    );
  	}
}

export default injectIntl(Infracciones);
